type Configuration = {
  locale: string;
};

// base64 encoded: `hugot-director-webclient:configuration@1`
// if you need to modify a schema of value, you also modify this key and need to migrate them
const STORAGE_KEY = 'aHVnb3QtZGlyZWN0b3Itd2ViY2xpZW50OmNvbmZpZ3VyYXRpb25AMQ==';

class ConfigurationStorage {
  private readonly storage: Storage;

  constructor({ storage }: { storage: Storage }) {
    this.storage = storage;
  }

  public loadLanguage = (): string | null => {
    const jsonString = this.storage.getItem(STORAGE_KEY);

    if (!jsonString) return null;

    return deserialize(jsonString).locale;
  };

  public saveLanguage = (locale: string): void => {
    this.mergeSave({ locale });
  };

  private mergeSave = (configuration: Partial<Configuration>): void => {
    const previousValue = deserialize(this.storage.getItem(STORAGE_KEY) || '{}');

    this.storage.setItem(STORAGE_KEY, serialize({ ...previousValue, ...configuration }));
  };
}

const serialize = (configuration: Configuration): string => JSON.stringify(configuration);

const deserialize = (jsonString: string): Configuration => {
  try {
    const json = JSON.parse(jsonString);

    return json;
  } catch (err) {
    throw new Error('Deserialization Failed.');
  }
};

export default ConfigurationStorage;
